import { ImageBackups, ImageContinuity, ImageCustodian, ImageEscrow, ImageSaasEscrow } from 'src/components/Svg/Images';
import { AppProductTypeEnum } from 'src/graphql/schema';

type ProductTypeDisplay = {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
};

export const productTypeMap: Record<AppProductTypeEnum, ProductTypeDisplay> = {
  [AppProductTypeEnum.SoftwareEscrow]: { label: 'Software Escrow', icon: ImageEscrow },
  [AppProductTypeEnum.SaasEscrow]: { label: 'SaaS Escrow', icon: ImageSaasEscrow },
  [AppProductTypeEnum.ContinuityEscrow]: { label: 'Continuity Escrow', icon: ImageContinuity },
  [AppProductTypeEnum.Backup]: { label: 'Software Backup', icon: ImageBackups },
  [AppProductTypeEnum.CustodianProfile]: { label: 'Software Custodian', icon: ImageCustodian },
};
